export const LogoMark = ({ size = 36, className = "", tone = "emerald" }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" className={className} aria-hidden="true">
    <rect width="48" height="48" rx="12" fill={tone === "white" ? "#FFFFFF" : "#087F5B"} />
    <path
      d="M17 36V12.5h14M17 23.5h11"
      fill="none"
      stroke={tone === "white" ? "#087F5B" : "#FFFFFF"}
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="32" cy="34" r="3" fill={tone === "white" ? "#087F5B" : "#8FE3C2"} />
  </svg>
);

export const Logo = ({ size = 34, tone = "emerald", onDark = false, className = "" }) => (
  <span className={`inline-flex items-center gap-2.5 ${className}`}>
    <LogoMark size={size} tone={tone} />
    <span
      className={`font-display text-[22px] font-black leading-none tracking-[0.04em] ${
        tone === "white" || onDark ? "text-white" : "text-ink"
      }`}
    >
      FAIZ
    </span>
  </span>
);
